(function () {
  'use strict';

  angular.module('eclipseApp.socialMedia').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('socialMedia', {
        url: '/social-media',
        parent: 'app',
        data: {
          authRequired: true,
        },
        params :{
          accountNumber : '',
          ctn : '',
        },
        title: "socialMedia",
        views: {
          content: {
            templateUrl: 'modules/social-media/views/social-media.html',
            controller: 'socialMediaCtrl'
          }
        }
      });
  }]);

})();
